const baseApp = {
  help: {
    metaData: 'https://docs.push.delivery/',
    apiCredentials: 'https://docs.push.delivery/',
    joltTransformation: 'https://docs.push.delivery/#push-templates',
    connectedTags: 'https://docs.push.delivery/',
    apnsSettings: 'https://docs.push.delivery/#ios-push-input-format'
  },
  appTemplate: {
    platformId: '2',
    apiUser: {
      name: '',
      clearTextPassword: '',
      accessToken: ''
    },
    iconUrl: '',
    parameters: {
      senderId: '',
      pushTemplate: '',
      defaultPayload: 'true',
    },
    parameterInfos: {},
    tags: [],
    groups: []
  }
};

export const defaultWebsdkConfig = {
  globalScope: true,
  app: {
    client: {
      defaultUrl: null,
      autosubscribe: false,
      defaultSubscribedTags: []
    },
    api: {
      id: null,
      platformId: null,
      baseUrl: null,
      accessToken: null
    },
    firebase: {
      projectId: null,
      apiKey: null,
      appId: null,
      messageSenderId: null,
      serviceWorkerPath: null
    },
    database: {
      notificationDB: "ethinking-notification",
      notificationTable: "notification",
      version: 1,
      notificationMaxResults: 50
    }
  },
  uiActive: true
}

export const common = {
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:622c7690-6f44-487a-96f7-19f963104d65',
  userPoolId: 'eu-west-1_A6iHI8ueY',
  clientId: '6dukhccik5iq36sad2cv3vfmat',
  oauthDomain: 'https://push-delivery.auth.eu-west-1.amazoncognito.com',
  platformConfigsUrl: 'https://console.push.delivery/config/dev/config.json',
  awsApiGateway: 'https://jf4mlv5wh0.execute-api.eu-west-1.amazonaws.com/production',
  //awsApiGateway: 'https://jf4mlv5wh0.execute-api.eu-west-1.amazonaws.com/stage',


  platformconfigs: {
    3: {
      ...baseApp,
      name: 'IOS',
      icon: 'IOS_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New IOS App',
        platformId: '3',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"title\": \"alertObj.title\",\n      \"message\": \"alertObj.body\",\n      \"url\": \"customFields.web-site-url\"\n    }\n  },\n  {\n    \"operation\": \"default\",\n    \"spec\": {\n      \"badge\": 0,\n      \"sound\": \"default\",\n      \"rich\": true\n    }\n  }\n]'
        },
      }
    },
    4: {
      ...baseApp,
      name: 'Safari',
      icon: 'Safari_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Safari App',
        platformId: '4',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"title\": \"alertObj.title\",\n      \"message\": \"alertObj.body\",\n      \"url\": \"url-args\"\n    }\n  }\n\n]'
        },
      }
    },
    7: {
      ...baseApp,
      name: 'Web Push',
      icon: 'WebPush_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Web Push App',
        platformId: '7',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"*\": \"&\",\n      \"url\": \"url\"\n    }\n  },\n  {\n    \"operation\": \"default\",\n    \"spec\": {\n      \"firebasePushType\": \"data\",\n      \"timeToLive\": \"1800\",\n      \"icon\": \"https://www.mywebsite.de/images/logo.jpg\",\n      \"url\": \"https://www.your-website.de\"\n    }\n  }\n]',
          websdkLogo: 'logo.svg',
          websdkSettingsIcon: 'wheel.svg',
          websdkConfig: JSON.stringify(defaultWebsdkConfig)
        }
      }
    },
    12: {
      ...baseApp,
      name: 'X dev',
      icon: 'x_gray-dev.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New X App (with X dev Account)',
        platformId: '12',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"message\": \"message\",\n      \"url\": \"url\"\n    }\n  }\n]'
        },
      }
    },
    14: {
      ...baseApp,
      name: 'Alexa',
      icon: 'Alexa_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Alexa App',
        platformId: '14',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"title\": \"data.title\",\n      \"message\": \"data.message\"\n    }\n  },\n  {\n    \"operation\": \"default\",\n    \"spec\": {\n      \"expiresAfterSeconds\": 86400\n    }\n  }\n]'
        },
      }
    },
    15: {
      ...baseApp,
      name: 'Android',
      icon: 'Android_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Android App',
        platformId: '15',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"priority\" : \"priority\",\n      \"ttl\": \"ttl\",\n      \"title\":\"customFields.title\",\n      \"message\":\"customFields.message\",\n      \"url\":\"customFields.url\"\n    }\n  },\n  {\n    \"operation\": \"default\",\n    \"spec\": {\n      \"pushScope\": \"token\"\n    }\n  }\n]'
        },
      }
    },
    16: {
      ...baseApp,
      name: 'Huawei',
      icon: 'Huawei_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Huawei App',
        platformId: '16',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"priority\" : \"priority\",\n      \"ttl\": \"ttl\",\n      \"message\": \"customFields.message\",\n      \"title\": \"customFields.title\",\n      \"url\": \"customFields.url\"\n    }\n  },\n  {\n    \"operation\": \"default\",\n    \"spec\": {\n      \"pushScope\": \"token\",\n      \"messageType\": \"data\"\n    }\n  }\n]'
        },
      }
    },
    17: {
      ...baseApp,
      name: 'Teams',
      icon: 'Teams_Gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Teams App',
        platformId: '17',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {        \n    \"operation\": \"shift\",\n    \"spec\": {        \n      \"message\": \"message\",\n    \"title\": \"title\",\n  \"url\": \"url\"\n   }        \n  }        \n]'
        },
      }
    },
    18: {
      ...baseApp,
      name: 'X',
      icon: 'x_gray.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New X App',
        platformId: '18',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"message\": \"message\",\n      \"url\": \"url\"\n    }\n  }\n]'
        },
      }
    },
    20: {
      ...baseApp,
      name: 'Email',
      icon: 'email.svg',
      appTemplate: {
        ...baseApp.appTemplate,
        name: 'New Email App',
        platformId: '20',
        parameters: {
          ...baseApp.appTemplate.parameters,
          pushTemplate: '[\n  {\n    \"operation\": \"shift\",\n    \"spec\": {\n      \"message\": \"message\",\n      \"url\": \"url\"\n    }\n  }\n]'
        },
      }
    },
  },
};
